module.exports = __webpack_public_path__ + "static/media/client-intertanko.4ae5d99e.jpg";